/**
 * Manager who provides device informations
 */

import Manager from "../../managers/Manager";

export const TECHNOLOGY_WIFI = 100;
export const TECHNOLOGY_GSM = 101;
export const TECHNOLOGY_ETHERNET = 102;
export const TECHNOLOGY_UNKNOWN = 0;

export const NAVIGATOR_CONNECTION_TYPE_CELL = "cellular";
export const NAVIGATOR_CONNECTION_TYPE_ETH = "ethernet";
export const NAVIGATOR_CONNECTION_TYPE_WIFI = "wifi";

export default class DeviceManager extends Manager {
    /**
     * Constructor
     */
    constructor() {
        super();
        /**
         * @type {string}
         */
        this.privateIp = null;
    }

    /**
     * Retrieve private ip adress and set into property privateIp
     */
    retrievePrivateIpAddress() {
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;   //compatibility for firefox and chrome
        if (window.RTCPeerConnection) {
            let self = this;
            var pc = new RTCPeerConnection({iceServers: []}), noop = function () {};
            pc.createDataChannel("");    //create a bogus data channel
            pc.createOffer(pc.setLocalDescription.bind(pc), noop);    // create offer and set local description
            pc.onicecandidate = (ice) => {  //listen for candidate events
                if (!ice || !ice.candidate || !ice.candidate.candidate)  return null;
                self.privateIp = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
                pc.onicecandidate = noop;
            }
        } else {
            this.privateIp = null;
        }
    }

    /**
     * Returns the private ip in cache
     *
     * @returns {string} private ip address
     */
    getPrivateIpAddress() {
        return this.privateIp;
    }

    /**
     * Returns the technology id
     *
     * @returns {number} technology
     */
    getTechnology() {
        if (typeof navigator !== 'undefined' && navigator && navigator.connection && (navigator.connection.type || navigator.connection.effectiveType)) {
            const connectionType = navigator.connection.type ? navigator.connection.type : navigator.connection.effectiveType;
            if (connectionType === NAVIGATOR_CONNECTION_TYPE_CELL) {
                return TECHNOLOGY_GSM;
            } else if (connectionType === NAVIGATOR_CONNECTION_TYPE_ETH) {
                return TECHNOLOGY_ETHERNET;
            } else if (connectionType === NAVIGATOR_CONNECTION_TYPE_WIFI) {
                return TECHNOLOGY_WIFI;
            }
        }

        return TECHNOLOGY_UNKNOWN;
    }

}


// WEBPACK FOOTER //
// ./js/core/device/manager/DeviceManager.js